/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').
factory('InternUsageProduct_Resource',["$resource","$location", function ($resource,$location)
{
    var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
    var  resourceOrderS = $resource(baseUrl + 'rest/internUsageProducts/:id',{}, {
        query: { method: 'GET', isArray: true },
        get:   { method: 'GET' }
    });
    return resourceOrderS;
}
]);

angular.module('FlexyBeautyApp.services').
factory('InternUsageProduct',["InternUsageProduct_Resource","ProductCategoryData","ProductData","InternUsageProductData","HumanResourceData",
    function (InternUsageProduct_Resource,ProductCategoryData,ProductData,InternUsageProductData,HumanResourceData)
    {

        var  InternUsageProduct = function (InternUsageProductRes,isPreviousVersion)
        {
            this.id = null;
            this.label = null;
            this.price = 0;
            this.originalPrice =0;
            this.quantity = 0;
            this.product = null;
            this.usageProduct = null;
            this.version = null;
            this.humanResource = null;
            this.loadObject(InternUsageProductRes)
            this.loadRef();
            if (isPreviousVersion == undefined || !isPreviousVersion)//A previous version is not added to DATA
                InternUsageProductData.add(this);
        }

        InternUsageProduct.prototype.loadObject = function(object)
        {

            if (object !== undefined && object != null)
            {
                if (!this.id)
                    this.id = object.id;
                this.label = object.label;
                this.originalPrice = object.originalPrice;
                this.price = object.price;
                this.quantity = object.quantity;
                this.productId = object.productId;
                this.humanResourceId = object.humanResourceId;
                if (object.version)
                    this.version = object.version;
            }
        };

        InternUsageProduct.prototype.loadRef = function()
        {
            if (this.productId)
                this.product = ProductData.getById(this.productId);
            if (this.humanResourceId)
                this.humanResource = HumanResourceData.getById(this.humanResourceId);
        };

        InternUsageProduct.prototype.copyDataTo = function(object)
        {

            object.id = this.id;
            object.label = this.label;
            object.originalPrice = this.originalPrice;
            object.price = this.price;
            object.quantity = this.quantity;

            if (this.product)
                object.productId = this.product.id;
            else
                object.productId = null;

            if (this.usageProduct)
                object.usageProductId = this.usageProduct.id;
            else
                object.usageProductId = null;

            if (this.humanResource)
                object.humanResourceId = this.humanResource.id;
            else
                object.humanResourceId = null;
        };
        InternUsageProduct.prototype.getObjectResource = function()
        {
            var internUsageProductRes = new InternUsageProduct_Resource();
            this.copyDataTo(internUsageProductRes);
            return internUsageProductRes;
        };
        InternUsageProduct.prototype.setIdUsingObject = function(object)
        {
            this.id = object.id;
        };
        InternUsageProduct.prototype.setId = function(id)
        {
            this.id = id;
        };
        InternUsageProduct.prototype.getId = function()
        {
            return this.id;
        };
        InternUsageProduct.prototype.getLabel = function()
        {
            return this.label;
        };
        InternUsageProduct.prototype.getPrice = function()
        {
            return this.price;
        };

        return InternUsageProduct;
    }
]);

angular.module('FlexyBeautyApp.services').
factory('InternUsageProductSrv',["$log","ServerSrv","DayData","InternUsageProductData","InternUsageProduct","ActivitySrv","UsageProductData",
    function ($log,ServerSrv,DayData,InternUsageProductData,InternUsageProduct,ActivitySrv,UsageProductData)
    {
        var  bpSrv = {};

        bpSrv.save =  function(InternUsageProduct,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(bpSrv.saveSync, InternUsageProduct, successFunction, errorFunction);
        };
        bpSrv.saveSync =  function(InternUsageProduct,successFunction,errorFunction)
        {
            //$timeout (function () {

            var bsRes = InternUsageProduct.getObjectResource();
            bsRes.$save({}, //no params
                function (data) {
                try {
                        InternUsageProduct.setId(data.id);
                        if (!InternUsageProduct.version || (data.version && data.version > InternUsageProduct.version))
                            InternUsageProduct.version = data.version;

                        if (successFunction != undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        bpSrv.updateLocally = function(id,resource)
        {
            //not specific code to manage update/remove from InternUsageProduct because this link is change only for a add or delete
            //return ActivitySrv.updateLocally(resource);
            //TODO
        };
        bpSrv.removeLocally =  function(id,resource)
        {
            var internUsageProduct = InternUsageProductData.getById(id)
            if (internUsageProduct != null)
            {
                if(internUsageProduct.usageProduct)
                    internUsageProduct.usageProduct.removeOrderProduct(internUsageProduct);
            }
            return InternUsageProduct;
        };
        bpSrv.addLocally = function(id,resource)
        {
            var internUsageProduct = InternUsageProductData.getById(id)
            if (internUsageProduct != null) //check if resource already exist inside index (current action could be a 'cancel')
                internUsageProduct.loadObject(resource);
            else
            {
                internUsageProduct = new InternUsageProduct(resource);
                internUsageProduct.id = id;
            }

            if(resource.usageProductId)
            {
                var usageProduct = UsageProductData.getById(resource.usageProductId);
                if (usageProduct)
                    usageProduct.addInternUsageProduct(usageProduct);
            }

            return usageProduct;
        };
        bpSrv.getPreviousVersionInstance =  function(resource)
        {
            var internUsageProduct = new InternUsageProduct(resource,true);
            if(resource.usageProductId)
                internUsageProduct.usageProduct = InternUsageProductData.getById(resource.usageProductId);
            return internUsageProduct;

        };

        return bpSrv;
    }
]);

angular.module('FlexyBeautyApp.services').
factory('InternUsageProductData',["$log", function ($log)
{
    var  internUsageProductData =
        {
            indexInternUsageProducts: []
        };
    internUsageProductData.getById = function(InternUsageProductId)
    {
        for (var i=0;i<this.indexInternUsageProducts.length;i++)
            if (this.indexInternUsageProducts[i].id == InternUsageProductId)
                return this.indexInternUsageProducts[i];
        return null;
    }
    internUsageProductData.getIndexOf = function(internUsageProduct)
    {
        if (internUsageProduct)
            return this.indexInternUsageProducts.indexOf(internUsageProduct);
        return -1;
    }
    internUsageProductData.getByIndex = function(index)
    {
        if (index>=0 && index < this.indexInternUsageProducts.length)
            return this.indexInternUsageProducts[index];
        else
            return null;
    }
    internUsageProductData.add = function(internUsageProduct)
    {
        this.indexInternUsageProducts.push(internUsageProduct);
        return this.indexInternUsageProducts.length-1;
    }
    internUsageProductData.clear = function()
    {
        internUsageProductData.indexInternUsageProducts = [];
    }


    return internUsageProductData;
}]);



// WEBPACK FOOTER //
// ./js/services/models/InternUsageProduct.js